import { reverseArray } from "../../../../../../Common/IterableUtils";
import { IEvaluationContext } from "../IEvaluationContext";
import { IExecutable } from "../IExecutable";

import { IExecutionPlanStep } from "./ExecutionPlanStep";

export class CalculationFunctionExecutionPlan {
    private readonly steps: IExecutionPlanStep[] = [];
    private readonly executable: IExecutable;

    public constructor(executable: IExecutable) {
        this.executable = executable;
    }

    public addStep(step: IExecutionPlanStep): void {
        this.steps.push(step);
    }

    public execute(context: IEvaluationContext): void | Promise<void> {
        let resultAction = (ctx: IEvaluationContext) => this.executable.execute(ctx);
        for (const step of reverseArray(this.steps)) {
            const stepExecutor = step.getStepExecutor();
            resultAction = stepExecutor(resultAction);
        }
        return resultAction(context);
    }

    public toDebugString(): string {
        return Iterator.from(this.steps)
            .map(x => x.toDebugString())
            .reduce((x, y) => (x === "" ? y : x + ", " + y), "");
    }
}
